import React from 'react';

// Whether the content in scope filters by the entity page's entity, for
// content without a dashboard gadget or report of its own to say so (a
// Studio block previewed as an entity; see GadgetSettingsScope). Read by
// useFilterInput alongside the gadget's and report's own setting.
const EntityFilterScopeContext = React.createContext<{
  isEntityFilterEnabled: boolean;
}>({ isEntityFilterEnabled: false });

export default EntityFilterScopeContext;
